/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ComputeLengthResponse
 */
export interface ComputeLengthResponse {
    /**
     * 
     */
    triggeredCaptureIds: Array<string>;
    /**
     * 
     */
    flowRunIds: Array<string>;
}

/**
 * Check if a given object implements the ComputeLengthResponse interface.
 */
export function instanceOfComputeLengthResponse(value: object): value is ComputeLengthResponse {
    if ((!('triggeredCaptureIds' in (value as Record<string, any>)) && !('triggered_capture_ids' in (value as Record<string, any>))) || ((value as Record<string, any>)['triggeredCaptureIds'] === undefined && (value as Record<string, any>)['triggered_capture_ids'] === undefined)) return false;
    if ((!('flowRunIds' in (value as Record<string, any>)) && !('flow_run_ids' in (value as Record<string, any>))) || ((value as Record<string, any>)['flowRunIds'] === undefined && (value as Record<string, any>)['flow_run_ids'] === undefined)) return false;
    return true;
}

export function ComputeLengthResponseFromJSON(json: any): ComputeLengthResponse {
    return ComputeLengthResponseFromJSONTyped(json, false);
}

export function ComputeLengthResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComputeLengthResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'triggeredCaptureIds': json['triggered_capture_ids'],
        'flowRunIds': json['flow_run_ids'],
    };
}

export function ComputeLengthResponseToJSON(json: any): ComputeLengthResponse {
    return ComputeLengthResponseToJSONTyped(json, false);
}

export function ComputeLengthResponseToJSONTyped(value?: ComputeLengthResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'triggered_capture_ids': value['triggeredCaptureIds'],
        'flow_run_ids': value['flowRunIds'],
    };
}

